var countdownDOTD = function(){
	const helpers = new formHelpers4i();
	let countdownTimerElement, countdownInterval, orderCount;
	let counters = [];
	
	const countDownToTime = (countdownElementID, countdownEndTime, serverRequestTime, id, DealID) => {
    		counters[id] = 0;
	    	var timeDiff = (countdownEndTime.getTime() - serverRequestTime.getTime()) / 1000;
	    	if (timeDiff > 0) countdownInterval = setInterval(() => { updateTimeLeft(countdownElementID, timeDiff, id, DealID); }, 1000);
	},
	updateTimeLeft = (countdownElementID, timeDiff, id, DealID) => {
	    	timeDiff = timeDiff - counters[id];
	    	if (timeDiff <= 0) {
	        	if (countdownElementID == "countdownTime0") {
				blockUI("Wait for it...");
	            		clearInterval(orderCount);
				location.reload(true);
	        	} else {
				blockUI("Uh-oh! :( This deal is gone! Let's look for another...");
	            		clearInterval(orderCount);
	            		location.reload(true);
	        	}	
	    	} else {
	        	let hoursLeft = (Math.floor((timeDiff / 60) / 60)).toString();
	        	let minutesLeft = (Math.floor((timeDiff / 60) % 60)).toString();
	        	let secondsLeft = (Math.floor(timeDiff % 60)).toString();
	        	if (hoursLeft == 1 && minutesLeft == 0 && secondsLeft == 0) {
	            		location.reload();
	            		return;
	        	}
	        	if (hoursLeft.length < 2) hoursLeft = '0' + hoursLeft;
	        	if (minutesLeft.length < 2) minutesLeft = '0' + minutesLeft;
	        	if (secondsLeft.length < 2) secondsLeft = '0' + secondsLeft;
	       		       	
	       	countdownTimerElement = document.getElementById(countdownElementID);
	        	if (hoursLeft == 0) {
	            		if (minutesLeft == 0) {
	                		countdownTimerElement.innerHTML = '00:00:' + secondsLeft;
	            		} else {
	                		countdownTimerElement.innerHTML = '00:' + minutesLeft + ':' + secondsLeft;
	            		}
	        	} else {
	            		countdownTimerElement.innerHTML = hoursLeft + ":" + minutesLeft + ':' + secondsLeft;
	        	}
	        	counters[id] = counters[id] + 1; //prodId undefined
	    	}
	},
	blockUI = (message) => {
		if(document.getElementsByClassName("blockThisMessage")[0])
		{
			document.getElementsByClassName("blockThisMessage")[0].innerHTML = message;
			const loading = document.getElementsByClassName("blockThis")[0];
			loading.classList.remove("hide");
		}
	},
	quantityLeft = (elementId, dealId) => {
    		setTimeout(() => { updateCount(elementId, dealId); }, 10000);
    		orderCount = setInterval(() => { updateCount(elementId, dealId); }, 30000);
	},
	updateCount = (elementId, dealId) => {
    		fetch("/dealoftheday/Deals/CheckOrderCount/" + dealId, {
        		method: "GET",
			headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
    		}).then(response => response.text())
		.then(response => {
			var intDealId = parseInt(response);
		
			if (intDealId > 0) {
            			document.getElementById(elementId).innerHTML = intDealId;
        		} else {
	            		clearInterval(orderCount);
        		}
    		}).catch(function(error) {
        		console.log(error);
    		});
	};
	
	return{
		CountDownToTime: countDownToTime,
		QuantityLeft: quantityLeft
	};
};